// client/src/api/ApiRegions.js
import flex from './FlexFetch'

const endpoint = '/api/1.0/regions/'

const cache = new Map()

function unwrapRegionsResponse(payload) {
  if (
    payload &&
    payload.success === true &&
    Object.prototype.hasOwnProperty.call(payload, 'data')
  ) {
    if (Array.isArray(payload.data?.items)) {
      return payload.data.items
    }

    return payload.data
  }

  return payload
}

async function getAll() {
  const response = await flex.flexFetch(endpoint + 'all')
  return unwrapRegionsResponse(await flex.handleResponse(response))
}

async function getById(region_id) {
  if (cache.has(region_id)) {
    return cache.get(region_id)
  }
  const response = await flex.flexFetch(`${endpoint}get?region_id=${region_id}`)
  const data = unwrapRegionsResponse(await flex.handleResponse(response))
  cache.set(region_id, data)
  return data
}

async function create(region) {
  const response = await flex.flexFetch(endpoint + 'post', {
    method: 'POST',
    body: JSON.stringify(region),
  })
  return unwrapRegionsResponse(await flex.handleResponse(response))
}

async function update(region) {
  const response = await flex.flexFetch(endpoint + 'put', {
    method: 'PUT',
    body: JSON.stringify(region),
  })
  return unwrapRegionsResponse(await flex.handleResponse(response))
}

async function remove(region_id) {
  const response = await flex.flexFetch(
    `${endpoint}delete?region_id=${region_id}`,
    {
      method: 'DELETE',
    },
  )
  return unwrapRegionsResponse(await flex.handleResponse(response))
}

const ApiRegions = {
  getAll,
  getById,
  create,
  update,
  remove,
}

export function clearCache() {
  cache.clear()
}

export default ApiRegions
